import React, { useState } from 'react';
import { 
  Paper, Typography, Box, Tabs, Tab, List, ListItem, 
  ListItemText, Divider, Chip, IconButton, useTheme
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoIcon from '@mui/icons-material/Info';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import NotificationsIcon from '@mui/icons-material/Notifications';

const AlertsLogs = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();
  
  const alerts = [
    { 
      id: 1, 
      type: 'warning', 
      message: 'Unusual resistance detected during tape removal', 
      time: '14:32:45' 
    },
    { 
      id: 2, 
      type: 'info', 
      message: 'Object contents verified against manifest', 
      time: '14:30:12' 
    },
    { 
      id: 3, 
      type: 'error', 
      message: 'Gripper calibration recommended', 
      time: '14:15:33' 
    }
  ];
  
  const logs = [
    { id: 1, action: 'Started unpacking sequence', status: 'completed', time: '14:29:00' },
    { id: 2, action: 'Identified package type', status: 'completed', time: '14:29:05' },
    { id: 3, action: 'Located tape edge', status: 'completed', time: '14:29:12' },
    { id: 4, action: 'Gripped tape', status: 'completed', time: '14:29:18' },
    { id: 5, action: 'Removed tape', status: 'in_progress', time: '14:29:30' },
    { id: 6, action: 'Opened first flap', status: 'completed', time: '14:30:00' },
    { id: 7, action: 'Opened second flap', status: 'completed', time: '14:30:05' },
    { id: 8, action: 'Checked contents', status: 'completed', time: '14:30:10' },
  ];
  
  const getAlertIcon = (type) => {
    switch (type) {
      case 'error': return <ErrorOutlineIcon color="error" fontSize="small" />;
      case 'warning': return <WarningAmberIcon sx={{ color: '#FFC107' }} fontSize="small" />;
      case 'info': return <InfoIcon sx={{ color: theme.palette.bmwAccent.lightBlue }} fontSize="small" />;
      default: return <InfoIcon color="info" fontSize="small" />;
    }
  };
  
  const getStatusChip = (status) => {
    switch (status) {
      case 'completed': 
        return (
          <Chip 
            size="small" 
            label="Completed" 
            sx={{ 
              bgcolor: 'rgba(76, 175, 80, 0.15)', 
              color: '#4CAF50',
              borderColor: 'rgba(76, 175, 80, 0.3)',
              fontWeight: 600,
              border: '1px solid',
              '& .MuiChip-label': { px: 1 }
            }} 
          />
        );
      case 'in_progress': 
        return (
          <Chip 
            size="small" 
            label="In Progress" 
            sx={{ 
              bgcolor: 'rgba(33, 150, 243, 0.15)', 
              color: theme.palette.bmwAccent.lightBlue,
              borderColor: 'rgba(33, 150, 243, 0.3)',
              fontWeight: 600,
              border: '1px solid',
              '& .MuiChip-label': { px: 1 }
            }} 
          />
        );
      case 'failed': 
        return <Chip size="small" label="Failed" color="error" variant="outlined" />;
      default: 
        return <Chip size="small" label={status} color="default" variant="outlined" />;
    }
  };
  
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6">
          Alerts & Logs
        </Typography>
        <IconButton size="small" aria-label="clear all">
          <ClearAllIcon fontSize="small" />
        </IconButton>
      </Box>
      
      <Tabs
        value={tabValue}
        onChange={(e, newValue) => setTabValue(newValue)}
        variant="fullWidth"
        sx={{ mb: 2 }}
      >
        <Tab label="Alerts" />
        <Tab label="Event Logs" />
      </Tabs>
      
      <Box sx={{ overflow: 'auto', flex: 1 }}>
        {tabValue === 0 ? (
          <List dense disablePadding>
            {alerts.map((alert) => (
              <React.Fragment key={alert.id}>
                <ListItem dense>
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    {getAlertIcon(alert.type)}
                  </Box>
                  <ListItemText
                    primary={alert.message}
                    secondary={alert.time}
                    primaryTypographyProps={{ variant: 'body2' }}
                    secondaryTypographyProps={{ variant: 'caption' }}
                  />
                </ListItem>
                <Divider component="li" />
              </React.Fragment>
            ))}
          </List>
        ) : (
          <List dense disablePadding>
            {logs.map((log) => (
              <React.Fragment key={log.id}>
                <ListItem dense>
                  <ListItemText
                    primary={log.action}
                    secondary={log.time}
                    primaryTypographyProps={{ variant: 'body2' }}
                    secondaryTypographyProps={{ variant: 'caption' }}
                  />
                  <Box sx={{ ml: 1 }}>
                    {getStatusChip(log.status)}
                  </Box>
                </ListItem>
                <Divider component="li" />
              </React.Fragment>
            ))}
          </List>
        )}
      </Box>
    </Paper>
  );
};

export default AlertsLogs; 